<template>
  <searchable-select
    outlined
    dense
    light
    clearable
    :hide-details="hideDetails"
    two-line
    :readonly="readonly"
    return-object
    item-value="id"
    :label="label"
    :item-text="
      item =>
        [
          item.project && item.project.code,
          item.name,
          item.address,
          item.project && item.project.name,
          item.project && item.project.orderer && item.project.orderer.companyName,
        ]
          .filter(Boolean)
          .join(' ')
    "
    :search-text="
      item =>
        [
          item.project && item.project.code,
          item.name,
          item.address,
          item.project && item.project.name,
          item.project && item.project.orderer && item.project.orderer.companyName,
        ]
          .filter(Boolean)
          .join(' ')
    "
    :search-placeholder="$t('sites.search')"
    :value="value"
    :items="groupedSites"
    :disabled="saving"
    :multiple="multiple"
    :rules="[required && $rules.required].filter(Boolean)"
    @change="v => this.$emit('change', v)"
    @menu="onMenu"
  >
    <template v-if="icon" v-slot:prepend>
      <v-icon>mdi mdi-map-legend</v-icon>
    </template>
    <template v-slot:selection="data">
      <v-list-item style="max-width: 100%" two-line class="ml-n4">
        <v-list-item-content>
          <v-list-item-title>{{
            [data.item.project && data.item.project.code, data.item.name].filter(Boolean).join(' ')
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ subtitle(data.item) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:item="data">
      <v-list-item two-line v-bind="data.attrs" v-on="data.on">
        <v-list-item-content>
          <v-list-item-title class="text-wrap">
            <v-icon v-if="data.item.favorite && !favoritable" small color="amber darken-2" class="no-gradient mr-1 mt-n1">mdi-star</v-icon
            >{{ [data.item.project && data.item.project.code, data.item.name].filter(Boolean).join(' ') }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-wrap">{{ subtitle(data.item) }}</v-list-item-subtitle>
        </v-list-item-content>
        <!-- Suosikin vaihto rivillä; painike pysäyttää klikin, joten rivi ei valikoidu. -->
        <v-list-item-action v-if="favoritable" class="my-0 ml-2 align-self-center">
          <site-favorite-button :site="data.item" small />
        </v-list-item-action>
      </v-list-item>
    </template>
  </searchable-select>
</template>

<script>
import SearchableSelect from '@/components/SearchableSelect';
import SiteFavoriteButton from '@/components/Sites/SiteFavoriteButton';
import { frozenFavoriteCheck, groupSites } from '@/helpers/siteFavorites';

export default {
  name: 'SiteCombobox',
  components: { SearchableSelect, SiteFavoriteButton },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    value: [Object, Array],
    sites: {
      type: Array,
    },
    label: {
      type: String,
      default: '',
    },
    readonly: Boolean,
    saving: Boolean,
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: true,
    },
    scheduledSitesOnly: {
      type: Boolean,
      default: false,
    },
    // Riveillä on tähtipainike, jolla työmaan voi lisätä suosikkeihin tai poistaa niistä.
    favoritable: {
      type: Boolean,
      default: true,
    },
    // Viimeksi käytettyjen työmaiden id:t järjestyksessä; näytetään omana ryhmänään suosikkien jälkeen.
    recentSiteIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Valikon ollessa auki ryhmittely perustuu avaushetken suosikkeihin, jotta tähden napsautus ei
      // siirrä riviä käyttäjän silmien alla. Null = elävä tilanne.
      frozenIsFavorite: null,
    };
  },
  computed: {
    filteredSites() {
      let sites;
      if (this.scheduledSitesOnly) {
        sites = this.sites.filter(s => s.plannedStartDate !== null);
      } else {
        sites = this.sites;
      }
      return sites;
    },
    groupedSites() {
      return groupSites(this.filteredSites, this.$t.bind(this), {
        isFavorite: this.frozenIsFavorite || undefined,
        recentIds: this.recentSiteIds,
      });
    },
  },
  methods: {
    onMenu(open) {
      this.frozenIsFavorite = open ? frozenFavoriteCheck(this.filteredSites) : null;
    },
    subtitle(item) {
      return [item.address, item.project && item.project.orderer && item.project.orderer.companyName]
        .filter(Boolean)
        .join(' | ');
    },
  },
};
</script>

<style scoped></style>
